/* FERRY AUTO-GENERATED: DO NOT EDIT THIS FILE */ /* eslint-disable */ // @ts-nocheck
import { ferryFetch } from "@ecom-alliance/libs";
import * as api from "../../api";
import * as creator_contact from "../data/creator_contact";
export { api, creator_contact };
import { method, headers, queryStringify } from "../../_util";
export var CreatorContactApiSens = /*#__PURE__*/function () {
  function CreatorContactApiSens(uriPrefix) {
    this.uriPrefix = typeof uriPrefix !== "undefined" ? uriPrefix : "";
  }
  var _proto = CreatorContactApiSens.prototype;
  _proto.IsCreatorInfoFilled = function IsCreatorInfoFilled(request, option) {
    var query = queryStringify(request);
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/affiliate/creator_marketplace/filled/get" + query;
    return ferryFetch(uri, {
      method: method,
      headers: headers
    }, option);
  };
  _proto.GetCreatorContactInfo = function GetCreatorContactInfo(request, option) {
    var query = queryStringify(request);
    var uri = this.uriPrefix + "/api_sens/v" + (request.version || "1") + "/affiliate/creator_marketplace/get" + query;
    return ferryFetch(uri, {
      method: method,
      headers: headers
    }, option);
  };
  _proto.MGetCreatorContactInfo = function MGetCreatorContactInfo(request, option) {
    var uri = this.uriPrefix + "/api_sens/v" + (request.version || "1") + "/affiliate/creator_marketplace/mget";
    var body = request;
    return ferryFetch(uri, {
      method: "POST",
      headers: headers,
      body: body
    }, option);
  };
  _proto.GetSellerContactInfo = function GetSellerContactInfo(request, option) {
    var query = queryStringify(request);
    var uri = this.uriPrefix + "/api_sens/v" + (request.version || "1") + "/affiliate/seller/contact_info/get" + query;
    return ferryFetch(uri, {
      method: method,
      headers: headers
    }, option);
  };
  _proto.UpdateSellerContactInfo = function UpdateSellerContactInfo(request, option) {
    var uri = this.uriPrefix + "/api_sens/v" + (request.version || "1") + "/affiliate/seller/contact_info/update";
    var body = request;
    return ferryFetch(uri, {
      method: "POST",
      headers: headers,
      body: body
    }, option);
  };
  _proto.GetSellerInvitationContactInfo = function GetSellerInvitationContactInfo(request, option) {
    var query = queryStringify(request);
    var uri = this.uriPrefix + "/api_sens/v" + (request.version || "1") + "/affiliate/seller/invitation/contact_info/get" + query;
    return ferryFetch(uri, {
      method: method,
      headers: headers
    }, option);
  };
  _proto.UpdateSellerInvitationContactInfo = function UpdateSellerInvitationContactInfo(request, option) {
    var uri = this.uriPrefix + "/api_sens/v" + (request.version || "1") + "/affiliate/seller/invitation/contact_info/update";
    var body = request;
    return ferryFetch(uri, {
      method: "POST",
      headers: headers,
      body: body
    }, option);
  };
  return CreatorContactApiSens;
}();
export var creatorContactApiSensClient = new CreatorContactApiSens();